// extracted by mini-css-extract-plugin
export default {"reportWrapper":"styles_reportWrapper__CztZw"};